import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

import { prepareAuthHeaders } from '../../utils/prepareAuthHeaders';

export const aiApi = createApi({
    reducerPath: 'aiApi',
    keepUnusedDataFor: 0,
    baseQuery: fetchBaseQuery({
        baseUrl: '/Ai',
        prepareHeaders: prepareAuthHeaders,
    }),
    endpoints: (builder) => ({
        getPrompt: builder.query({
            query: ({prompt}) => ({
                url: `/Prompt`,
                method: 'GET',
                params: {prompt}
            }),
        }),
        getDataFromDb: builder.query({
            query: ({prompt}) => ({
                url: `/GetDataFromDb`,
                method: 'GET',
                params: {prompt}
            }),
        }),
    }),
});

export const {
    useGetPromptQuery,
    useGetDataFromDbQuery
} = aiApi;
